import { TravelHospitalityPageProvider } from "../../context/industryPageProviders";
import IndustryPageLayout from "./IndustryPageLayout";

export default function TravelHospitality() {
  return (
    <TravelHospitalityPageProvider>
      <IndustryPageLayout />
    </TravelHospitalityPageProvider>
  );
}
